import { useEffect, useState } from 'react';
import { Button } from './components';

interface InstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: InstallPromptEvent | null = null;
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e as InstallPromptEvent;
  });
}

const isStandalone = () =>
  typeof window !== 'undefined' && (window.matchMedia?.('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true);
const isIos = () => typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent);

/** «Instalar KEORA» en el celular: botón en Android/Chrome, instrucciones en iPhone. */
export function InstallApp() {
  const [can, setCan] = useState(Boolean(deferred));
  const [done, setDone] = useState(false);
  useEffect(() => {
    const on = (e: Event) => {
      e.preventDefault();
      deferred = e as InstallPromptEvent;
      setCan(true);
    };
    window.addEventListener('beforeinstallprompt', on);
    return () => window.removeEventListener('beforeinstallprompt', on);
  }, []);
  if (isStandalone() || done) return null;
  if (can && deferred) {
    return (
      <div className="install-app">
        <span>Instala KEORA en tu celular para abrirla como una app.</span>
        <Button
          variant="secondary"
          onClick={() => {
            const d = deferred;
            deferred = null;
            setCan(false);
            void d?.prompt().then(() => d.userChoice).then((c) => c.outcome === 'accepted' && setDone(true));
          }}
        >
          Instalar
        </Button>
      </div>
    );
  }
  if (isIos()) {
    return <p className="install-app small">Para instalar KEORA en tu iPhone: toca Compartir y luego «Agregar a pantalla de inicio».</p>;
  }
  return null;
}
